import { defineStore } from 'pinia';
import { ValuationService } from 'src/services';
import type { AutoTraderValuation, Valuation } from 'src/types/valuations';
import { useAuthStore } from './auth-store';
import valuationService from 'src/services/valuation-service';

export const useValuationStore = defineStore('valuation', {
  state: () => ({
    valuations: [] as Valuation[]
  }),
  actions: {
    setValuations(valuations: Valuation[]) {
      this.valuations = valuations;
      
    },
    getValuations(): Promise<Valuation[]> {
      return new Promise((resolve, reject) => {
        const authStore = useAuthStore();
        const selectedDealers = authStore.selectedDealers;

        if (selectedDealers) {
          if (selectedDealers.length <= 20) {
            let valu: Valuation[] = [];
            let tasks: Promise<Valuation[]>[] = [];
            useAuthStore().selectedDealers!.forEach(d => {
              tasks.push(
                new Promise<Valuation[]>((resolve, reject) => {
                  ValuationService.getValuations(d.affiliateUserId).then(res => {
                    valu = valu.concat(res);
                    resolve(res)
                  }).catch((error) => {
                    resolve([]);
                  })
                })
              )
            })
            Promise.all(tasks).then(() => {
              this.valuations = valu.sort((a, b) => {
                return new Date(b.created!).getTime() - new Date(a.created!).getTime()
              });

              
              resolve(valu);
            }).catch(error => {
              console.log("Error fetching valuations:", error);
              reject("ERROR_FETCHING_VALUATIONS");
            });
          } else {
            this.valuations = [];
            resolve([])
          }
        } else {
          ValuationService.getValuations(useAuthStore().affiliateUserId).then(res => {
            this.valuations = res;
            resolve(res)
          }).catch((error) => {
            this.valuations = [];
            resolve([]);
          })
        }
      });
    },
    async createValuation(valuation: Valuation): Promise<boolean> {
      return new Promise((resolve, reject) => {
        ValuationService.saveValuation(valuation).then(res => {
          if (res) {
            const i = this.valuations.findIndex(v => v.vrm === valuation.vrm);
            i > -1 ? this.valuations.splice(i, 1) : null;
            this.valuations.unshift(res);
            resolve(true);
          }
          reject(false)
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  persist: true
});
